import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  pageStyle,
  colors,
  typography,
  buttons,
  radius,
  shadows,
} from "../../theme";
import Spinner from "../common/Spinner";
import { formatPhoneRu } from "../../utils/formatPhoneRu";

function ArchivePage() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch("/api/students/archived")
      .then(r => r.json())
      .then(data => setStudents(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      style={{
        background: colors.bg,
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <div style={pageStyle}>
        <button
          onClick={() => navigate("/")}
          style={{
            ...buttons.subtle,
            fontSize: 24,
            marginBottom: 18,
            borderRadius: radius.pill,
          }}
        >
          ← Выйти из архива
        </button>

        <h1
          style={{
            fontSize: typography.pageTitle,
            margin: 0,
            marginBottom: 20,
            color: "#92400e",
          }}
        >
          Архив
        </h1>

        {loading && (
          <div
            style={{
              padding: 20,
            }}
          >
            <Spinner size={36} />
          </div>
        )}

        {!loading && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
              gap: 20,
            }}
          >
            {students.map(s => (
              <div
                key={s.id}
                onClick={() =>
                  navigate(`/student/${s.id}`, { state: { fromArchive: true } })
                }
                style={{
                  padding: 24,
                  background: colors.card,
                  borderRadius: radius.card,
                  cursor: "pointer",
                  boxShadow: shadows.card,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch",
                }}
              >
                <div
                  style={{
                    background: "#fef3c7",
                    color: "#92400e",
                    fontSize: 16,
                    padding: "6px 10px",
                    borderRadius: `${radius.card}px ${radius.card}px 0 0`,
                    fontWeight: 500,
                    textAlign: "center",
                    margin: "-24px -24px 12px -24px",
                  }}
                >
                  Архив
                </div>

                <div
                  style={{
                    marginBottom: 6,
                    color: colors.textMain,
                    fontSize: 32,
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {s.name}
                </div>
                {s.phone && (
                  <div
                    style={{
                      fontSize: typography.body,
                      marginTop: "auto",
                      color: colors.textSoft,
                    }}
                  >
                    {formatPhoneRu(s.phone)}
                  </div>
                )}
              </div>
            ))}

            {students.length === 0 && (
              <div
                style={{
                  fontSize: typography.bodyLarge,
                  color: colors.textSoft,
                  paddingTop: 8,
                }}
              >
                В архиве пока никого нет
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default ArchivePage;
